module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#album",
      toString: function () {
        return this.url;
      }
    }